import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PageHeader } from "@/components/AppShell";
import { Spinner } from "@/components/Gate";
import { Button } from "@/components/ui/button";
import { Progress } from "@/components/ui/progress";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { errMsg, useApi } from "@/lib/api";

export default function MyCourses() {
  const api = useApi();
  const [items, setItems] = useState(null);
  const [tab, setTab] = useState("active");
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get("/learn/my-courses").then((r) => setItems(r.data)).catch((e) => setErr(errMsg(e)));
  }, [api]);
  if (err) return <p className="text-rose-600">{err}</p>;
  if (!items) return <Spinner />;
  const shown = items.filter((i) => (tab === "completed" ? i.enrolment.completed_at : !i.enrolment.completed_at));
  return (
    <div>
      <PageHeader eyebrow="Learn" title="My courses" />
      <Tabs value={tab} onValueChange={setTab} className="mb-6">
        <TabsList>
          <TabsTrigger value="active" data-testid="my-courses-tab-active">In progress</TabsTrigger>
          <TabsTrigger value="completed" data-testid="my-courses-tab-completed">Completed</TabsTrigger>
        </TabsList>
      </Tabs>
      {shown.length === 0 ? (
        <div className="rounded-2xl border border-dashed border-slate-300 p-10 text-center" data-testid="my-courses-empty">
          <p className="text-slate-500">{tab === "completed" ? "No completed courses yet." : "You haven't started any courses."}</p>
          <Button asChild variant="outline" className="mt-4"><Link to="/learn/courses">Browse the library</Link></Button>
        </div>
      ) : (
        <div className="space-y-3" data-testid="my-courses-list">
          {shown.map(({ course, progress, resume_lesson_id, enrolment }) => (
            <div key={course.id} className="flex flex-col gap-4 rounded-2xl border border-slate-200 bg-white p-5 sm:flex-row sm:items-center" data-testid={`my-course-${course.id}`}>
              <div className="flex-1">
                <Link to={`/learn/courses/${course.id}`} className="font-display text-lg font-bold text-slate-900 hover:text-[#222d99]">{course.title}</Link>
                <div className="mt-3 flex items-center gap-3">
                  <Progress value={progress.percent} className="h-2 max-w-xs" />
                  <span className="text-sm text-slate-600">{progress.percent}% · {progress.required_done}/{progress.required_total} required</span>
                </div>
                {enrolment.completed_at && <p className="mt-2 text-xs text-emerald-700">Completed {new Date(enrolment.completed_at).toLocaleDateString()}</p>}
              </div>
              {resume_lesson_id && (
                <Button asChild className="rounded-full bg-[#222d99] hover:bg-[#1a237e]" data-testid={`my-course-resume-${course.id}`}>
                  <Link to={`/learn/lessons/${resume_lesson_id}`}>{progress.percent ? "Resume" : "Start"}</Link>
                </Button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
